import _ from 'lodash';

// The fields the lyrics editor writes, as opposed to the song's own
export const EDITOR_FIELDS = ['currentPart', 'partNumber', 'currentLyrics', 'currentRepeatCount'];

/**
 * The form's data after the song is loaded again. A load lands with an empty editor, so one that
 * arrives after a part was opened — StrictMode runs the load twice, and the song list arriving
 * reruns it — would wipe the part out from under the edit. While a part is open, the editor keeps
 * what it has.
 */
export const withOpenPartKept = (loaded, current, isEditing) =>
  isEditing ? { ...loaded, ..._.pick(current, EDITOR_FIELDS) } : loaded;

// Escape cancels the part edit, but not while a modal is open over the form — closing the modal
// is that Escape's job, and the part stays open under it
export const escapeCancelsEdit = (event) => event.key === 'Escape' && !document.querySelector('.Modal');
